
import { defineComponent, onBeforeMount } from 'vue';
import router from '@/router';
import ServicoApp from '@/servicos/ServicoApp';
import GerenciadorAutenticacao from '../gerenciadores/GerenciadorAutenticacao';

export default defineComponent({
  name: 'ValidarLogin',
  components: {

  },
  setup() {
    function voltar() {
      router.back();
    }
    const gerenciadorAutenticacao = new GerenciadorAutenticacao();

    async function deslogar() {
      const retornoAutenticacao = await new ServicoApp().deslogar();
      if (!retornoAutenticacao.autenticado) {
        gerenciadorAutenticacao.removerDadosAutenticacao();
        router.push({ name: 'Login' });
      }
    }

    onBeforeMount(async () => {
      deslogar();
    });
    return {
      voltar,
      deslogar,
    };
  },
});
